"use client";
import { useEffect, useState } from "react";
import { Container, Skeleton, Text } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { LayoutProps } from "@/components/layout/layoutType";
import Icon from "@/components/common/icon/sicon";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });

export default function Offline({ params }: { params?: LayoutProps }) {
  const t = useTranslations("alert");
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Container size="1" className=" mt-16 lg:mt-32 text-center group">
      <Skeleton loading={loading}>
        <Icon
          iconType="phosphor"
          iconName="WifiSlash"
          className={
            "size-64 inline-block animate-infinite animate-pulse animate-duration-[1500ms] animate-delay-500 animate-fill-backwards"
          }
          weight="thin"
          size={64}
        />
      </Skeleton>

      <Skeleton loading={loading}>
        <Text as="div" size="4" weight="bold" className="flex min-w-12 justify-center mt-12">
          {t("offline_text")}
        </Text>
      </Skeleton>
    </Container>
  );
}
